import Registry from '../../../global/Registry';
import UserSignedUp from '../domain/aggregates/user/events/UserSignedUp';
import UserSignedIn from '../domain/aggregates/user/events/UserSignedIn';
import UserSignedOut from '../domain/aggregates/user/events/UserSignedOut';
import Api from '../../../../foundation/api/Api';
import User from '../domain/aggregates/user/User';
import AuthenticationTokenApi from './AuthenticationTokenApi';
import Timepoint from '../../../../foundation/time/Timepoint';

export default class UserApi extends Api<User> {

	private static instance?: UserApi;

	public static getInstance () {
		return this.instance !== undefined ? this.instance : this.instance = new this(Registry.getInstance().userRepository);
	}

	public async me (source = '') {
		const url = '/api/users/me';

		try {
			return await this.getOne(url);

		} catch (error) {
			// if (![401, 404].includes(error.response.status)) {
			// 	throw error;
			// }

			await Registry.getInstance().removeErrorMessage();

			await AuthenticationTokenApi.getInstance().createToken({ source });

			return await this.getOne(url);
		}
	}

	public async signUp (username: string, emailAddress: string, password: string) {
		const data = {
			username: username,
			email_address: emailAddress,
			password: password
		};

		const user = await this.postOne('/api/users/sign-up', data);

		Registry.getInstance().me = user;

		await Api.publish(new UserSignedUp(user.getId()));

		return user;
	}

	public async signUpOrganization (organizationType: string, organizationName: string, firstName: string, lastName: string, emailAddress: string, password: string) {
		const data = {
			organizationType,
			organizationName,
			firstName,
			lastName,
			emailAddress,
			password
		};

		const user = await this.postOne('/api/users/organization-sign-up', data);

		Registry.getInstance().me = user;

		await Api.publish(new UserSignedUp(user.getId()));

		return user;
	}

	public async signIn (emailAddress: string, password: string) {
		const data = {
			emailAddress: emailAddress,
			password: password
		};

		await AuthenticationTokenApi.getInstance().createToken(data);

		const user = await this.me();

		Registry.getInstance().me = user;

		await Api.publish(new UserSignedIn(user.getId()));

		return user;
	}

	public async signInWithSingleSignInToken (singleSignInToken: string) {
		const data = { singleSignInToken };

		await AuthenticationTokenApi.getInstance().createToken(data);

		const user = await this.me();

		Registry.getInstance().me = user;
		Registry.getInstance().singleSignInTokenLoginTimepoint = Timepoint.now();

		await Api.publish(new UserSignedIn(user.getId()));

		return user;
	}

	public async changePreference (type: string, value: any) {
		const data = { type, value };

		const user = await this.postOne('/api/users/change-preference', data);

		Registry.getInstance().me = user;

		return user;
	}

	public async signOut () {
		const authenticationTokenRepository = Registry.getInstance().authenticationTokenRepository;

		const authenticationToken = authenticationTokenRepository.getToken();

		if (authenticationToken === undefined) {
			return;
		}

		await AuthenticationTokenApi.getInstance().revokeToken(authenticationToken);

		await AuthenticationTokenApi.getInstance().createToken();

		const user = await this.me();

		Registry.getInstance().me = user;

		await Api.publish(new UserSignedOut(user.getId()));

		return user;
	}

	public async resetPassword (emailAddress: string) {
		const data = {
			email_address: emailAddress
		};

		await this.post('/api/users/reset-password', data);
	}

	public async changePassword (newPassword: string, currentPassword?: string) {
		const data = {
			newPassword,
			currentPassword
		};

		await this.post('/api/users/change-password', data);
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/users/api/UserApi.ts